import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import externalExamGroupsStore from '../../../../../stores/external-exam-groups-store';
import { UpdateExternalExamGroupRequest } from '../../../../../api/types/external-exams/external-exam-group-crud';

export const updateExternalExamGroupOperation = async (
  groupId: number,
  request: UpdateExternalExamGroupRequest,
  setLoading: (isLoading: boolean) => void,
  onHide: () => any,
) => {
  try {
    if (!request.groupName || request.groupName.trim().length === 0) {
      toast.warn(`יש להזין את שם המקבץ`);
      return;
    }
    if (!request.year || request.year <= 0) {
      toast.warn(`יש לבחור שנה אקדמית`);
      return;
    }
    if (!request.groupRegistrationDueDate) {
      toast.warn(`יש לבחור תאריך אחרון להרשמה של סטודנטים`);
      return;
    }

    setLoading(true);
    const res = await appApi.updateExternalExamGroup(groupId, request);
    if (res.data.ok) {
      await externalExamGroupsStore.fetchGroups();
      toast.success(`עדכון מקבץ התבצע בהצלחה`);
      onHide();
    } else {
      toast.error(`עדכון מקבץ נכשל, נסה שוב בעוד מספר רגעים...`);
    }
    setLoading(false);
  } catch (e) {
    toast.error('עדכון מקבץ נכשל, נסה שוב בעוד מספר רגעים...');
    console.error(`updateExternalExamGroupOperation failed: ${e}`);
    setLoading(false);
  }
};
